import { useState, useEffect, useRef } from 'react'
import { formatDate, format_time } from '../../components/Util/format_date'
import { translateWord } from '../../components/Util/util'

import './EpgInfo.scss'

export default ({ epg, activeChannelId, listChannels }) => {

    const [selectedEpgCurrent, setSelectedEpgCurrent] = useState({})
    const [selectedEpgNext, setSelectedEpgNext] = useState({})
    const [infoEpg, setInfoEpg] = useState({})

    const _channel = useRef('')


    useEffect(() => {
        if (epg) {

            if (listChannels[0]?.channels) _channel.current = listChannels[0].channels.find(e => e.id == activeChannelId)

            let _epg = {}
            if (epg.Now) {
                setSelectedEpgCurrent(epg.Now)
                setSelectedEpgNext(epg.next)
                _epg = epg.Now
            } else {
                setSelectedEpgCurrent(epg)
                setSelectedEpgNext({})
                _epg = epg
            }

            try {

                let obj
                let objInfo = JSON.parse(_epg.info)
                let objIcon = JSON.parse(_epg.icon)

                obj = { ...objInfo[0], ...objIcon[0] }

                setInfoEpg({ ...obj })

            } catch (e) {

            }
        }

    }, [epg]);

    const get_current_time = () => {
        let date = new Date();

        let utcYear = date.getUTCFullYear();
        let utcMonth = date.getUTCMonth() + 1; // Months are zero-indexed, so add 1
        let utcDay = date.getUTCDate();
        let utcHours = date.getUTCHours();
        let utcMinutes = date.getUTCMinutes();
        let utcSeconds = date.getUTCSeconds();

        // Format the UTC time as a string
        var utcTime = utcYear + "-" + utcMonth + "-" + utcDay + " " + utcHours + ":" + utcMinutes + ":" + utcSeconds;

        let time = new Date(utcTime).getTime() / 1000

        return time
    }

    const epg_image_source = () => {

        let _url = ''

        if (_channel.current?.archived_channel?.type == "flussonic") {

            if (epg) {

                let _epg = epg

                // Get UTC time components
                let date, utcYear, utcMonth, utcDay, utcHours, utcMinutes, utcSeconds

                if (epg.Now) {

                    _epg = epg.Now

                    date = new Date(_epg.start_ut * 1000);

                    utcYear = date.getUTCFullYear().toString().padStart(2, "0");
                    utcMonth = (date.getUTCMonth() + 1).toString().padStart(2, "0");; // Months are zero-indexed, so add 1
                    utcDay = date.getUTCDate().toString().padStart(2, "0");
                    utcHours = date.getUTCHours().toString().padStart(2, "0");
                    utcMinutes = date.getUTCMinutes().toString().padStart(2, "0");
                    utcSeconds = date.getUTCSeconds().toString().padStart(2, "0");
                } else {
                    date = new Date(_epg.start_ut * 1000);

                    // Get UTC time components

                    utcYear = date.getFullYear().toString()
                    utcMonth = (date.getMonth() + 1).toString().padStart(2, "0");
                    utcDay = date.getDate().toString().padStart(2, "0");
                    utcHours = date.getHours().toString().padStart(2, "0");
                    utcMinutes = date.getMinutes().toString().padStart(2, "0");
                    utcSeconds = date.getSeconds().toString().padStart(2, "0");

                }



                _url = `${_channel.current?.archived_channel?.url}/${utcYear}/${utcMonth}/${utcDay}/${utcHours}/${utcMinutes}/${utcSeconds}.jpg`
            }

        } else {
            _url = infoEpg.src || ''
        }

        return _url
    }

    return (
        <>
            {selectedEpgCurrent.stop_ut && <>

                <div className="parent_epg_info_live">

                    <div className="img_epg_live" style={{ backgroundImage: `url(${epg_image_source()})` }}></div>

                    <div className="main_epg_info_live">

                        <h3 className="title_epg_info_live">{selectedEpgCurrent.title || selectedEpgCurrent.title}</h3>

                        <div className="about_live_info">
                            <div className="date_desc_field">{selectedEpgCurrent ? formatDate(new Date(selectedEpgCurrent.date), 'yyyy') : null}</div>
                            {
                                infoEpg.genre && infoEpg.genre.length ?
                                    <div className="genre_desc_field">
                                        {infoEpg.genre.map((e, i) => infoEpg.genre.length === i + 1 ? e.name + '' : e.name + ',')}
                                    </div>
                                    : null
                            }
                            <div className="pg_desc_field">
                                <span>{selectedEpgCurrent && selectedEpgCurrent.pg && selectedEpgCurrent.pg != 0 ? '+' + selectedEpgCurrent.pg : translateWord('All')}</span>
                            </div>
                        </div>

                        <div className="progress_epg_info_live">
                            <div className="progress_bar_epg_info_live" style={epg ?
                                {

                                    width: `${(
                                        (get_current_time() - selectedEpgCurrent.start_ut) / (selectedEpgCurrent.stop_ut - selectedEpgCurrent.start_ut) * 100) > 100
                                        ? 100 : ((get_current_time() - selectedEpgCurrent.start_ut) / (selectedEpgCurrent.stop_ut - selectedEpgCurrent.start_ut) * 100) < 0
                                            ? 0 : (get_current_time() - selectedEpgCurrent.start_ut) / (selectedEpgCurrent.stop_ut - selectedEpgCurrent.start_ut) * 100}%`
                                }
                                : null}
                            ></div>
                        </div>

                        <div className="parent_duration_epg_live">
                            <p className="start_end_time_epg_live">{selectedEpgCurrent ? `${formatDate(new Date(selectedEpgCurrent.start_ut * 1000), 'HH:mm')} - ${formatDate(new Date(selectedEpgCurrent.stop_ut * 1000), 'HH:mm')}` : null}</p>
                            <p className="duration_epg_live">{epg ? format_time(selectedEpgCurrent.stop_ut - selectedEpgCurrent.start_ut) : null}</p>
                        </div>


                        {/* <div className="casts_list_epg_live">
                        <h4>Actors: </h4>
                        <div className='actors_list_epg_live'>
                            <a href="">actor 1,</a>
                            <a href="">actor 2,</a>
                            <a href="">actor 3</a>
                        </div>
                    </div> */}

                        <div className="description_epg_info_live">
                            {/* <h4>About Movie</h4> */}
                            <p>
                                {infoEpg.desc && infoEpg.desc.length > 300 ? infoEpg.desc.slice(0, 300) + '...' : infoEpg.desc}
                            </p>
                        </div>

                    </div>

                </div>
                {
                    selectedEpgNext && Object.keys(selectedEpgNext).length != 0 ?
                        <div className="next_epg_info_live card_color">
                            <h4>{translateWord('Next')}</h4>
                            <h5>
                                <span className='name_program'> {selectedEpgNext.title || selectedEpgNext.name}</span>
                                <span className='time_program'>{selectedEpgNext ? `${formatDate(new Date(selectedEpgNext.start_ut * 1000), 'HH:mm')} - ${formatDate(new Date(selectedEpgNext.stop_ut * 1000), 'HH:mm')}` : null} </span>
                            </h5>
                        </div>
                        : null
                }

            </>}
        </>
    )
}